module.exports = __webpack_public_path__ + "img/mobile_icon3.5bc7fa0a.png";